<template>
  <div>
    <yxt-switch
      v-model="getValue"
      :active-value="1"
      :inactive-value="0"
      @change="switchChange"
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    ></yxt-switch>
    <span class="tlive-create__switch--text tlive-create__tip">
      {{
        $t(
          'pc_biz_willShowCompanyInThisLiveRoom' /* 开启后，将在直播间展示企业 */
        )
      }}
      logo
      <span
        v-show="goToSet"
        class="set-logo"
        @click="goSetLogo"
      >
        {{ $t('pc_biz_setLogo' /* 去设置logo */) }}
      </span>
    </span>
  </div>
</template>
<script>
import { fetchLogo } from '../services/http';
export default {
  name: 'LiveLogo',
  inject: ['isGroupOrg'],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {
      goToSet: false,
      logoUrl: '',
      showLogo: 0
    };
  },
  created() {
    this.fetchLogo();
  },
  methods: {
    // 开关 水印
    goSetLogo() {
      const navList =
        this.$store.state.navManageStore &&
        this.$store.state.navManageStore.navList;
      const code = this.isGroupOrg ? 'group_task_live_settings' : 'tlive_settings';
      const pms = navList.findIndex(nav => nav.code === code || nav.functionCode === code);
      if (pms < 0) {
        this.$message({
          message: `${this.$t('pc_biz_unauthorized' /* 没有权限 */)}`,
          type: 'error'
        });
        return;
      }
      window.location.href = `${window.location.origin}/tlive/#/${this.isGroupOrg ? 'orgsetting' : 'setting'}`;

    },
    async fetchLogo(callback = null) {
      const { logoUrl, showLogo } = await fetchLogo();
      this.logoUrl = logoUrl;
      this.showLogo = showLogo;
      if (this.showLogo === 0) {
        this.$emit('input', this.showLogo);
      }
      callback && callback();

    },
    async switchChange() {
      this.fetchLogo(() => {
        if (this.showLogo === 0) {
          this.goToSet = true;
        }
        if (this.showLogo === 1) {
          this.goToSet = false;
        }
      });
    }
  }
};
</script>
<style scoped lang="less"></style>
